module.exports = __webpack_public_path__ + "img/hero-human-working.47b937a9.png";